module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Space Black Titanium + Pine Green Open.1d4500c6.png";